@let supports = supports$ | async;
@let summary = summary$ | async;

<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Ajuda'"
    [titleIcon]="'pi pi-comments'"
    [subtitle]="'Acompanhe seus chamados e fale com o nosso time de atendimento.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Ajuda', icon: 'pi pi-comments' },
    ]"></app-page-header>

  <div class="container-fluid support">
    <!-- Cards de resumo por status -->
    <section class="support__summary-cards">
      @if (summary) {
        <app-status-summary-card
          label="ABERTOS"
          colorVariant="pending"
          [count]="summary.pending"
          [active]="activeStatusFilter === supportStatusEnum.PENDING"
          (cardClick)="handleStatusFilter(supportStatusEnum.PENDING)" />
        <app-status-summary-card
          label="EM ATENDIMENTO"
          colorVariant="in_progress"
          [count]="summary.in_progress"
          [active]="activeStatusFilter === supportStatusEnum.IN_PROGRESS"
          (cardClick)="handleStatusFilter(supportStatusEnum.IN_PROGRESS)" />
        <app-status-summary-card
          label="FINALIZADOS"
          colorVariant="finished"
          [count]="summary.finished"
          [active]="activeStatusFilter === supportStatusEnum.FINISHED"
          (cardClick)="handleStatusFilter(supportStatusEnum.FINISHED)" />
        <app-status-summary-card
          label="CANCELADOS"
          colorVariant="canceled"
          [count]="summary.canceled"
          [active]="activeStatusFilter === supportStatusEnum.CANCELED"
          (cardClick)="handleStatusFilter(supportStatusEnum.CANCELED)" />
      } @else {
        <p-skeleton height="90px" />
        <p-skeleton height="90px" />
        <p-skeleton height="90px" />
        <p-skeleton height="90px" />
      }
    </section>

    <!-- Busca + ações -->
    <section class="support__search-section">
      <div class="support__search">
        <p class="support__search-label">BUSCAR CHAMADO</p>
        <div class="support__search-field">
          <p-iconField iconPosition="left">
            <p-inputIcon>
              <i class="pi pi-search"></i>
            </p-inputIcon>
            <input pInputText [formControl]="tableFilter" placeholder="Buscar por título, descrição ou nº" />
          </p-iconField>
          @if (showSearchHint) {
            <small class="support__search-hint">Digite ao menos 3 caracteres para buscar.</small>
          }
        </div>
      </div>

      <div class="support__search-actions">
        @if (supports && supports.meta.total_count) {
          <app-paginator-report
            [meta]="supports.meta"
            [template]="'Exibindo {first}–{last} de {totalRecords} chamados'" />
        }
        <app-button styleType="outlined" [disabled]="!hasActiveFilters" (btnClick)="clearFilters()">
          Limpar filtros
        </app-button>
        <app-button icon="pi pi-plus" (btnClick)="openNewSupportDialog()">Abrir chamado</app-button>
      </div>
    </section>

    <section class="support__table-section">
      <app-support-table
        [data]="supports"
        [filtered]="hasActiveFilters"
        [loading]="isLoading()"
        (pageChange)="handlePageChange($event)"
        (viewDetailsClick)="handleViewDetails($event)" />
    </section>
  </div>
</app-layout>
